import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu } from "semantic-ui-react";
import { CAMPAIGN_PAGES } from "constants/pages";

function CampaignsBarTablet(props) {
  const { currentPageKey } = props;
  const { t } = useTranslation("common");
  return (
    <Menu secondary size="small" className="app-bar" pointing style={{ maxWidth: "700px" }}>
      {CAMPAIGN_PAGES.map((page) => (
        <Menu.Item key={page.key} as={Link} to={page.path} active={page.key === currentPageKey}>
          {t(page.tKey)}
        </Menu.Item>
      ))}
    </Menu>
  );
}

export default CampaignsBarTablet;
